import { TaskHandlerType } from "ui/Scripts/source/models/enums";
import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";

export interface ITaskHandler extends IModifyUser {
    taskHandlerType: TaskHandlerType;
}

export class TaskHandler extends ModifyUser implements ITaskHandler {
    taskHandlerType: TaskHandlerType;

    constructor();
    constructor(obj: ITaskHandler);
    constructor(obj?: any) {
        super(obj);
        this.taskHandlerType = obj && obj.taskHandlerType || TaskHandlerType.Handler;
    }

    static createTaskHandler(user: IModifyUser, taskHandlerType: TaskHandlerType): ITaskHandler {
        return new TaskHandler({
            ...user,
            taskHandlerType
        });
    }
}

export class SaveTaskHandler {
    userCode: string;
    taskHandlerType: TaskHandlerType;

    constructor();
    constructor(obj: ITaskHandler);
    constructor(obj?: any) {
        this.userCode = obj && obj.code || "";
        this.taskHandlerType = obj && obj.taskHandlerType || TaskHandlerType.Handler;
    }
}